import { type SupportedDefaultMenuItem } from '@ardoq/table';

export const autoSizeColumnProps = {
  getContextMenuItems: (): SupportedDefaultMenuItem[] => [
    'autoSizeThis',
    'autoSizeAll',
  ],
  maxAutoSizeWidth: 500,
};
